import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';

@Component({
  selector: 'lc-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  constructor(private dataservice: DataService) { }

  ngOnInit() {
    if( window.location.href.indexOf('smarttalks') > -1 ){
          window.location.href = 'https://smarttalks.philips-dentalcare.com/post/voorkomen-van-gaatjes-in-het-melkgebit-makkelijk-gezegd-makkelijk-gedaan';
          return;
    }
    let admin_location = window.location.href.replace('/orderadmin', '/newadmin/orders/new')
    // let base_url: string = this.dataservice.BASE_URL.split('-dot-').slice(-1)[0];
    // base_url = base_url.replace('https://','');
    // let admin_location = 'admin-dot-' + base_url;
    // if(!!window.location && (window.location.hostname.indexOf('dev') > -1)) {
    //   admin_location = 'dev-dot-' + admin_location;
    // }
    window.location.href = admin_location;
  }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/admin/admin.component.ts